import { HashRouter, useLocation } from 'react-router-dom';
import { AllRoutes } from './index';
import { useEffect } from 'react';
import { ConfigProvider } from 'contexts/configContext';

const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
        const timer = setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
        return () => clearTimeout(timer);
    }, [location]);

    return null;
};
const Routes = () => {
    return (
        <ConfigProvider>
            <HashRouter>
                <ScrollToTop />
                <AllRoutes />
            </HashRouter>
        </ConfigProvider>
    );
};

export default Routes;
